import { render, staticRenderFns } from "./QuestionDetails.vue?vue&type=template&id=fce1f3c8"
import script from "./QuestionDetails.vue?vue&type=script&lang=js"
export * from "./QuestionDetails.vue?vue&type=script&lang=js"
import style0 from "./QuestionDetails.vue?vue&type=style&index=0&id=fce1f3c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports